module.exports = __webpack_public_path__ + "img/tabletennis-dark.deb57643.svg";